module.exports = __webpack_public_path__ + "static/media/icon_liwuhe.a72d5e53.png";